import styled, { css } from 'styled-components'
import { PRIMARY_BLUE_03, PRIMARY_BLUE_07, PRIMARY_RED_01, SECONDARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'
import { getDashColor } from '../../styles'

type FooterProps = {
  isSimulation: boolean
}

// MOBILE
export const AdvanceMobileBox = styled.div`
  margin: 0;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
export const AmountMobileDiv = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
    margin-bottom: 40px;
  }
`
export const AdvanceControlsMobileBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px 25px 0px 25px;
  height: 100%;
  background-color: white;
`
export const MobileInputBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 212px;
  height: 96px;
`
export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const SimulationMobileBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: row;
  width: 100%;
`
export const AdvanceControlMobileBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 120px;
  flex-direction: column;
`
export const ControlFooterDiv = styled.div<FooterProps>`
  margin-left: -25px;
  margin-right: -30px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 310px;
  ${(props) => props.isSimulation && css`
    height: 260px;
  `}
`
export const MobileTarrifDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 5px;
`
export const CenterTextDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 39px;
  height: 150px;
`
// ------------------------------
// DESKTOP AND MOBILE
export const ErrorMessage = styled(styled.p``) <any>`
  display: none;
  color: ${PRIMARY_RED_01};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    margin: 0px;
    padding: 0px;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12.6px;
  }
  ${(props) => props.error && css`
    display: flex;
  `}
`
export const AvaliableValueTextBold = styled(styled.p``)`
  color: ${getDashColor('PRIMARY_BLUE_05', 'GRAY_DARK')};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.6px;
  margin-left: 10px;
  @media (max-width: 762px) {
    color: ${getDashColor('PRIMARY_BLUE_05', 'GRAY_DARK')};
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
  }
`
export const AvaliableValueText = styled(styled.p``)`
  color: ${getDashColor('PRIMARY_BLUE_05', 'GRAY_DARK')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  @media (max-width: 762px) {
    color: ${getDashColor('PRIMARY_BLUE_07', 'GRAY_DARK')};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.6px;
  }
`
export const TermsAndConditionInput = styled(styled.input``)`
  border-radius: 5px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  @media (max-width: 762px) {
    width: 20px;
    height: 20px;
  }
`
export const TermsAndConditionTextBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px;
  flex: 1;
`
export const ResultText = styled(styled.p``)`
  color: ${PRIMARY_BLUE_07};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
`
export const ResultValueText = styled(styled.p``)`
  color: ${PRIMARY_BLUE_03};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
`
export const TermsAndConditionText = styled(styled.p``)`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  flex: 1;
  @media (max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
export const TermsAndConditionLabel = styled.div`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  @media (max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 10px;
  }
`
export const TermsAndConditionLink = styled(styled.strong``) <any>`
  color: ${SECONDARY_BLUE_01};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
  @media (max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
// ------------------
// DESKTOP

export const InlineTextDiv = styled.div`
  display: flex;
  flex-direction: row;
`
export const DesktopContainer = styled.div``

export const AdvanceDesktopBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 660px;
  margin: 0;
  padding: 0;
`
export const AdvanceControlsDesktopBox = styled.div`
  width: 660px;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 660px;
  }
`
export const DesktopInputBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 315px;
  height: 190px;
  @media (max-width: 600px) {
    width: 212px;
    height: 96px;
    align-items: center;
  }
`
export const AdvanceIconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 35px;
  margin: 0px 30px 0px 30px;
  width: 42px;
  height: 190px;
  @media (max-width: 768px) {
    display: none;
    height: 62px;
    padding-top: 0px;
    margin: 10px 0px 20px 0px;
  }
`
export const SimulationDesktopBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 300px;
`
